import { format } from "date-fns";
import { ColumnFilter } from "./ColumnFilter";
import { useSelector } from "react-redux";
import { diapasonFilter, selectsFilter, dateRangeFilter } from "./functions";
import { usd } from "../../dataFunctions";

// dataGrid

const colorScale = (v) => {
  return v >= 50
    ? "colorScale50"
    : v >= 30
    ? "colorScale30"
    : v >= 20
    ? "colorScale20"
    : v >= 10
    ? "colorScale10"
    : v >= 5
    ? "colorScale5"
    : v == 0
    ? "colorScale0"
    : "colorScaleDefault";
};

export const statsColumns = (vaults) => [
  //{ field: "assetId", headerName: "Asset Id", width: 60 },
  { field: "Wallet", headerName: "Wallet", width: 100 },
  {
    field: "assetId",
    headerName: "Vault",
    renderCell: (params) => {
      let a = vaults.filter((el) => el.assetId == params.row.assetId);
      //console.log('a=',a);
      return (
        <div className="tdVault">
          <span className="vaultPlatf">
            {params.row.assetId}. {a[0].Blockchain}, {a[0].Platform}
          </span>
          <span className="vaultVlt">{a[0].Vault}</span>
        </div>
      );
    },
    width: 160,
  },
  {
    field: "balApr",
    headerName: "balAPR",
    description: "balAprDaily (daysBetw) = (maxBal / minBal - 1) / daysBetw ↲ balApr = balAprDaily * 365",
    renderCell: (params) => {
      return (
        <div className="tdVault">
          <span className="vaultPlatf">
            {params.row.balAprDaily.toFixed(4)} ({params.row.daysBetween})
          </span>
          <span className={"vaultVlt " + colorScale(params.row.balApr)}>
            {params.row.balApr.toFixed(1)}
          </span>
        </div>
      );
    },
    width: 140,
  },
  {
    field: "rwdApr",
    headerName: "rwdAPR",
    renderCell: (params) => {
      return (
        <div className="tdVault">
          <span className="vaultPlatf">
            {params.row.rwdAprDaily.toFixed(4)} ({params.row.daysBetween})
          </span>
          <span className={"vaultVlt " + colorScale(params.row.rwdApr)}>
            {params.row.rwdApr.toFixed(1)}
          </span>
        </div>
      );
    },
    width: 140,
  },
  { field: "minDt", headerName: "minDt", width: 160 },
  { field: "maxDt", headerName: "maxDt", width: 160 },
  { field: "minBal", headerName: "minBal", width: 160 },
  { field: "maxBal", headerName: "maxBal", width: 160 },
  { field: "minRwd", headerName: "minRwd", width: 80 },
  { field: "maxRwd", headerName: "maxRwd", width: 160 },
  { field: "cnt", headerName: "Count", width: 100 },
];

// MostAdvancedTable

export const tblColumns = [
  { accessor: "assetId", Header: "Asset Id", disableFilters: true, width: 60 },
  //{ accessor: "Datetime", Header: "Datetime",  width: 244, filterType: 'date', filter: dateRangeFilter },
  {
    accessor: "Wallet",
    Header: "Wallet",
    width: 160,
    filterType: "select",
    filter: selectsFilter,
  },
  {
    accessor: "Blockchain",
    Header: "Blockchain",
    width: 140,
    filterType: "select",
    filter: selectsFilter,
  },
  {
    accessor: "Platform",
    Header: "Platform",
    width: 140,
    filterType: "select",
    filter: selectsFilter,
  },
  { accessor: "Vault", Header: "Vault", width: 140 },
  {
    accessor: "Uses",
    Header: "Uses",
    width: 120,
    filterType: "select",
    filter: selectsFilter,
  },
  /*{
    accessor: "Balance",
    Header: "Balance",
    //width: 110,
    width: 180, filterType: 'slider', filter: diapasonFilter,
    Cell: (props) => usd(props.value, 8),//4
    // style: {
    //   textAlign: "right",
    // },
  },*/
  {
    accessor: "balAprDaily",
    Header: "balAPR",
    width: 160, // filterType: 'diapason', filter: diapasonFilter,
    Cell: (props) => usd(props.value, 1),
  },
  {
    accessor: "balApr",
    Header: "balAPR",
    width: 160,
    Cell: (props) => usd(props.value, 4),
  },
  // {
  // accessor: (obj) => (
  //   <div className="cellVault">
  //     <span className="cellVaultTitle">{obj.RewardToken?.replace(/,/g, ", ")}</span>
  //     <span className="cellVaultTokRates">{obj.RewardTokensUsd}</span>
  //   </div>
  // ),
  // Header: "RwdTokens", width: 130
  // },
];

/*
  const colorScale = (v) => {
    return v >= 50
      ? "colorScale50"
      : v >= 30
      ? "colorScale30"
      : v >= 20
      ? "colorScale20"
      : v >= 10
      ? "colorScale10"
      : v >= 5
      ? "colorScale5"
      : v == 0
      ? "colorScale0"
      : "colorScaleDefault";
  };
*/

/*
const statsColumns = [
  //{ field: "assetId", headerName: "Asset Id", width: 60 },
  
  // {
  //   field: "assetId", 
  //   headerName: "Vault",
  //   valueGetter: (params) => {
  //     //return params.row.assetId
  //     let a = vaults.filter( el => el.assetId == params.row.assetId ); 
  //     console.log('a=',a);
  //     return params.row.assetId + a[0].Platform + a[0].Vault;
  //   },
  //   width: 160,
  // },
  {
    field: "assetId",
    headerName: "Vault",
    renderCell: (params) => {
      //return params.row.assetId
      let a = vaults.filter((el) => el.assetId == params.row.assetId);
      //console.log('a=',a);
      return (
        <div className="tdVault">
          <span className="vaultPlatf">
            {params.row.assetId}. {a[0].Platform}, {a[0].Wallet}
          </span>
          <span className="vaultVlt">{a[0].Vault}</span>
        </div>
      );
    },
    width: 160,
  },
  {
    field: "balApr",
    headerName: "balAPR",
    renderCell: (params) => {
      return (
        <div className="tdVault">
          <span className="vaultPlatf">
            {params.row.balAprDaily.toFixed(4)} ({params.row.daysBetween})
          </span>
          <span className={"vaultVlt " + colorScale(params.row.balApr)}>
            {params.row.balApr.toFixed(1)}
          </span>
        </div>
      );
    },
    width: 140,
  },
  {
    field: "rwdApr",
    headerName: "rwdAPR",
    renderCell: (params) => {
      return (
        <div className="tdVault">
          <span className="vaultPlatf">
            {params.row.rwdAprDaily.toFixed(4)} ({params.row.daysBetween})
          </span>
          <span className={"vaultVlt " + colorScale(params.row.rwdApr)}>
            {params.row.rwdApr.toFixed(1)}
          </span>
        </div>
      );
    },
    width: 140,
  },
  { field: "minDt", headerName: "minDt", width: 160 },
  { field: "maxDt", headerName: "maxDt", width: 160 },
  { field: "minBal", headerName: "minBal", width: 160 },
  { field: "maxBal", headerName: "maxBal", width: 160 },
  { field: "minRwd", headerName: "minRwd", width: 80 },
  { field: "maxRwd", headerName: "maxRwd", width: 160 },
  { field: "cnt", headerName: "Count", width: 100 },
];
*/
